<template>
    <list-search showsSearch @search="setQuery">
        <v-row align="center">
            <v-col cols="12" md="4" lg="">
                <v-text-field label="기간(시작)" v-model="query.dates[0]" type="date" v-bind="attrs_input" clearable />
            </v-col>
            <v-col cols="12" md="4" lg="">
                <v-text-field label="기간(종료)" v-model="query.dates[1]" type="date" v-bind="attrs_input" clearable />
            </v-col>
            <v-col cols="12" md="4" lg="">
                <v-select label="상태" v-model="query.state" :items="states" placeholder="전체" clearable v-bind="attrs_input" />
            </v-col>
            <v-col cols="12" md="4" lg="">
                <v-select label="설비별" v-model="query._subject" :items="subjects" item-text="name" item-value="_id" placeholder="전체" clearable v-bind="attrs_input" />
            </v-col>
            <v-col cols="12" md="4" lg="">
                <!-- <v-text-field label="제목" v-model="query.searchValue" v-bind="attrs_input" @keydown.enter="setQuery" /> -->
            </v-col>
        </v-row>
    </list-search>
</template>

<script>
import api from "@/api";
import { attrs_input, RENTAL_SCHEDULE_STATES } from "@/assets/variables";

import ListSearch from "../dumb/list-search.vue";

let initQuery = () => ({
    dates: [],
    _subject: null,
    state: null,
    // searchValue: null,
});

let states = Object.values(RENTAL_SCHEDULE_STATES);

export default {
    components: {
        ListSearch,
    },
    data: () => ({
        query: initQuery(),

        subjects: [],
        states,

        attrs_input,
    }),
    mounted() {
        this.sync();
        this.init();
    },

    methods: {
        sync() {
            this.query = { ...initQuery(), ...this.$route.query };
        },
        async init() {
            let { subjects } = await api.console.rental.subjects.gets();
            this.subjects = subjects;
        },
        setQuery() {
            let { query: { ...query } = {} } = this;

            let hasStartDate = !!query?.dates?.[0];
            let hasEndDate = !!query?.dates?.[1];
            if (!hasStartDate && hasEndDate) throw new Error("시작 날짜를 설정해주세요");
            if (hasStartDate && !hasEndDate) throw new Error("종료 날짜를 설정해주세요");
            if (!hasStartDate && !hasEndDate) delete query.dates;

            query.page = 1;

            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
